import * as React from 'react';
import CallTableViewModel from '../../../ViewModels/CallTableViewModel';
import Grid from '@mui/material/Grid';
import { MsalContext } from '../../../Contexts/MsalContext';
import { SavedFiltersViewModel } from '../../../ViewModels/SavedFiltersViewModel';
import TextField from '@mui/material/TextField';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import IconButton from '@mui/material/IconButton';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import PersonIcon from '@mui/icons-material/Person';
import GroupsIcon from '@mui/icons-material/Groups';
import { Link as RouterLink } from "react-router-dom";
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';


interface IPresetSelector {
    callTableViewModel: CallTableViewModel;
    setCallTableViewModel: (value: CallTableViewModel) => void;
    close: () => void;
}

export default function PresetSelector(props: IPresetSelector) {

    //get the list of available preset for my name
    const { msalFetch } = React.useContext(MsalContext);
    const [filters, setFilters] = React.useState<SavedFiltersViewModel[]>([]);
    const [filterSearch, setFilterSearch] = React.useState<string>("");

    React.useEffect(() => {
        getSavedFilterList();
    }, [props.callTableViewModel.filters.client]);

    const getSavedFilterList = () => {
        if (props.callTableViewModel.filters.client !== '') {
            msalFetch('api/Search/GetSavedFilters?client=' + props.callTableViewModel.filters.client)
                .then(response => response.json())
                .then(data => {
                    setFilters(data);
                });
        }
    }

    const deleteFilter = (guid: string) => {
        msalFetch(`api/Search/DeleteSavedFilter?guid=${guid}`)
            .then(response => response.json())
            .then(data => {
                getSavedFilterList();
            });
    }

    const deleteLink = (guid: string) => {
        if (confirm('Are you sure you want to remove this filter?')) {
            deleteFilter(guid);
        }
    }

    return (
        <Grid container spacing={0}>
            <Grid container size={12} style={{ marginLeft: '5px' }}>
                <Grid size={12}>
                    <Typography variant="h6" fontWeight='bold' marginTop='8px'>Preset List</Typography>
                </Grid>
                <Grid size={12}>
                    <Typography variant="body1">Select a Preset below to apply previously saved filter and column values</Typography>
                </Grid>
                <Grid size={12}>
                    <TextField
                        fullWidth
                        label="Search the filters"
                        id="filter_search"
                        value={filterSearch}
                        style={{ marginBottom: "12px", marginTop: "12px" }}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            setFilterSearch(event.target.value.toLowerCase());
                        }}
                    />
                </Grid>
                {filters.map((preset, index) => <React.Fragment key={index}>
                    {
                        preset.filtersName.toLowerCase().includes(filterSearch) &&
                        <Grid size={12}>
                            <Card style={{ marginTop: '5px' }}>
                                <Grid container>
                                    <Grid size={10}>
                                        <CardActionArea
                                            component={RouterLink}
                                            to={'../SearchIndex?client=' + encodeURIComponent(props.callTableViewModel.filters.client) + '&filter=' + encodeURIComponent(preset.guid)}
                                            onClick={props.close}
                                            style={{ alignContent: 'center', height: '100%' }}>
                                            <h4 style={{ marginLeft: '10px', marginTop: '0px', marginBottom: '0px' }} >
                                                {preset.filtersName}
                                            </h4>
                                        </CardActionArea>
                                    </Grid>
                                    <Grid size={2} style={{ alignContent: 'center', textAlignLast: 'center' }} >
                                        {preset.role === 'User' ?
                                            <>
                                                <Tooltip title={<>Personal Filter</>}>
                                                    <PersonIcon style={{ verticalAlign: 'text-top' }} />
                                                </Tooltip>
                                                <IconButton style={{ marginLeft: '6px' }} onClick={() => deleteLink(preset.guid)}>
                                                    <Tooltip title={<>Remove Personal Filter</>}>
                                                        <DeleteForeverIcon />
                                                    </Tooltip>
                                                </IconButton>
                                            </>
                                            :
                                            <Tooltip title={<>Shared Filter, Can Not Be Deleted</>}>
                                                <GroupsIcon style={{ margin: '6px', verticalAlign: 'text-top' }} />
                                            </Tooltip>
                                        }
                                    </Grid>
                                </Grid>
                            </Card>
                        </Grid>
                    }
                </React.Fragment>)}
            </Grid>
        </Grid >
    )
}